<template>
  <div class="registrationResult">
    <div class="navbar">
      <span>{{ type ? '课程' : '活动' }}报名</span>
      <img src="@/assets/images/detail/back.png" alt="" class="back" @click="back" />
    </div>
    <div class="content d-f fxd-c ai-c">
      <img src="@/assets/images/detail/performance/status.png" alt="" class="status_icon" />
      <div class="result">报名成功</div>
      <div class="btn" @click="goRecord">查看报名记录</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'registrationResult',
  data() {
    return {
      type: '',
    }
  },
  methods: {
    back() {
      this.$router.go(-2)
    },
    goRecord() {
      if (this.type) {
        this.$myUni.navigateTo({
          url: '/pages/mine/train',
        })
      } else {
        this.$myUni.navigateTo({
          url: '/pages/mine/activity',
        })
      }
    },
  },
  mounted() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type
    }
  },
}
</script>
<style lang="scss" scoped>
.registrationResult {
  width: 100%;
  height: 100vh;
  background: #fff;
  position: relative;
  .navbar {
    z-index: 9999;
    width: 100%;
    height: 44px;
    position: fixed;
    top: calc(40px + env(safe-area-inset-top));
    left: 0;
    text-align: center;
    line-height: 44px;
    font-weight: 600;
    color: #112a26;
    font-size: 0.9rem;
    background: #fff;
    border-bottom: 1px solid #f4f4f4;
    .back {
      position: absolute;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      top: 0.5rem;
    }
  }
  .content {
    width: 100%;
    height: calc(100% - 44px - 40px - env(safe-area-inset-top));
    position: absolute;
    top: calc(44px + 40px + env(safe-area-inset-top));
    left: 0;
    overflow-y: auto;
    padding-top: 4rem;
    .status_icon {
      width: 5.2rem;
      height: 5.2rem;
      margin-bottom: 8px;
    }
    .result {
      font-size: 0.9rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.4rem;
    }
    .btn {
      margin-top: 2.6rem;
      text-align: center;
      width: 8rem;
      height: 2rem;
      line-height: 2rem;
      background: #a97048;
      border-radius: 1.1rem;
      font-size: 0.8rem;
      color: #ffffff;
    }
  }
}
</style>
